(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function init() {
    document.querySelectorAll(".qrp").forEach((root) => {
      const form = root.querySelector("form.qrp__form");
      if (!form) return;

      // If success message persists across visits (theme caching / editor),
      // hide it after it has been seen once on this device.
      const successBox = form.querySelector(".qrp__success");
      if (successBox) {
        try {
          const key = `qrp_success_seen_${root.getAttribute("data-section-id") || "default"}`;
          const alreadySeen = window.localStorage.getItem(key) === "1";
          if (alreadySeen) {
            successBox.style.display = "none";
          } else {
            window.localStorage.setItem(key, "1");
          }
        } catch (_) {
          // ignore storage errors
        }
      }

      const openConsentBtn = form.querySelector('[data-open-consent="1"]');
      const modalOverlay = form.querySelector('[data-consent-modal="1"]');
      const closeBtns = form.querySelectorAll('[data-close-consent="1"]');
      const consentSubmitBtn = form.querySelector('[data-consent-submit="1"]');
      const modalErrorBox = form.querySelector('[data-modal-error="1"]');

      function getConsentCheckboxes() {
        // Query at runtime to avoid stale/empty NodeLists in some environments.
        const scope = modalOverlay || form;
        return Array.from(
          scope.querySelectorAll('input[type="checkbox"][data-consent-checkbox="1"][data-required="1"]')
        );
      }

      function showInlineError(msg) {
        let box = form.querySelector(".qrp__inlineError");
        if (!box) {
          box = document.createElement("div");
          box.className = "qrp__inlineError";
          form.prepend(box);
        }
        box.textContent = msg;
        box.style.display = "block";
      }

      function clearInlineError() {
        const box = form.querySelector(".qrp__inlineError");
        if (box) box.style.display = "none";
      }

      function showModalError(msg) {
        if (!modalErrorBox) {
          showInlineError(msg);
          return;
        }
        modalErrorBox.textContent = msg;
        modalErrorBox.style.display = "block";
      }

      function clearModalError() {
        if (modalErrorBox) modalErrorBox.style.display = "none";
      }

      function openModal() {
        if (!modalOverlay) return;
        modalOverlay.setAttribute("aria-hidden", "false");
        modalOverlay.classList.add("is-open");
        const cbs = getConsentCheckboxes();
        const firstCb = cbs[0];
        if (firstCb) firstCb.focus();
      }

      function closeModal() {
        if (!modalOverlay) return;
        modalOverlay.setAttribute("aria-hidden", "true");
        modalOverlay.classList.remove("is-open");
        if (openConsentBtn) openConsentBtn.focus();
      }

      function allConsentsChecked() {
        const cbs = getConsentCheckboxes();
        // If there is a consent modal (agreements exist), at least 1 checkbox must exist,
        // and ALL of them must be checked.
        if (modalOverlay && cbs.length === 0) return false;
        return cbs.every((cb) => cb.checked);
      }

      function blockIfMissingConsents(e) {
        const requiredCbs = getConsentCheckboxes();

        // Fail-closed: modal exists but required checkboxes not found => do not submit.
        if (modalOverlay && requiredCbs.length === 0) {
          e.preventDefault();
          showModalError("Sözleşme kutuları yüklenemedi. Lütfen sayfayı yenileyip tekrar deneyin.");
          openModal();
          return true;
        }

        if (!allConsentsChecked()) {
          e.preventDefault();
          showModalError("Lütfen tüm zorunlu sözleşme/onay kutularını işaretleyin.");
          openModal();
          const firstUnchecked = getConsentCheckboxes().find((cb) => !cb.checked);
          if (firstUnchecked) {
            firstUnchecked.scrollIntoView({ behavior: "smooth", block: "center" });
            firstUnchecked.focus();
          }
          return true;
        }

        return false;
      }

      if (openConsentBtn) {
        openConsentBtn.addEventListener("click", () => {
          clearInlineError();
          clearModalError();

          // First validate required fields in the form (name/email/etc.),
          // but IGNORE required consent checkboxes (they are meant to be checked inside the modal).
          const requiredConsentEls = Array.from(
            form.querySelectorAll('input[type="checkbox"][data-consent-checkbox="1"][required]')
          );
          for (const el of requiredConsentEls) el.removeAttribute("required");

          const ok = form.checkValidity();
          if (!ok) {
            // Gövde form alanları eksikse hatayı modal içinde göster.
            openModal();
            showModalError("Lütfen kırmızıyla işaretlenen zorunlu alanları doldurun.");
            form.reportValidity();
            // restore required before returning
            for (const el of requiredConsentEls) el.setAttribute("required", "required");
            return;
          }

          // restore required after passing validation
          for (const el of requiredConsentEls) el.setAttribute("required", "required");

          openModal();
        });
      }

      if (modalOverlay) {
        modalOverlay.addEventListener("click", (e) => {
          // Click outside modal closes
          if (e.target === modalOverlay) closeModal();
        });
      }

      for (const btn of closeBtns) {
        btn.addEventListener("click", () => closeModal());
      }

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && modalOverlay && modalOverlay.classList.contains("is-open")) {
          closeModal();
        }
      });

      form.addEventListener("submit", (e) => {
        clearInlineError();
        blockIfMissingConsents(e);
      });

      if (consentSubmitBtn) {
        consentSubmitBtn.addEventListener("click", (e) => {
          clearInlineError();
          // Extra safety: block before native submit triggers.
          blockIfMissingConsents(e);
        });
      }
    });
  }

  ready(init);
})();
